var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { ReactComponent as Arrow } from "./arrow.svg";
import { ReactComponent as Edit } from "./edit.svg";
import { ReactComponent as Error } from "./error.svg";
import { ReactComponent as Cart } from "./cart.svg";
import { ReactComponent as CartSolid } from "./cart-solid.svg";
import { ReactComponent as Close } from "./close.svg";
import { ReactComponent as Calendar } from "./calendar.svg";
import { ReactComponent as Attachment } from "./attachment.svg";
import { ReactComponent as Pdf } from "./pdf.svg";
import { ReactComponent as Check } from "./check-mark.svg";
import { ReactComponent as Gear } from "./gear.svg";
import { ReactComponent as Help } from "./help.svg";
import { ReactComponent as Download } from "./download.svg";
import { ReactComponent as NotAllowed } from "./not-allowed.svg";
import { ReactComponent as Bolt } from "./bolt.svg";
import { ReactComponent as Submit } from "./bolt.svg";
import { ReactComponent as Search } from "./search.svg";
import { getClassName } from "../helpers";
import { SVG } from "../classConstants";
import { usePresentationComponent } from "../AppContext";
import parse from "html-react-parser";
import { Loader } from "../components/Loader/Loader";
var Spinner = styled(Loader)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: inherit;\n    position: relative;\n    display: inline-block;\n    &:before {\n        height: 100%;\n        width: 100%;\n        margin: 0;\n        top: 0;\n        left: 0;\n        border-top-width: 1px;\n        --spinner-color: currentColor; \n    }\n"], ["\n    height: inherit;\n    position: relative;\n    display: inline-block;\n    &:before {\n        height: 100%;\n        width: 100%;\n        margin: 0;\n        top: 0;\n        left: 0;\n        border-top-width: 1px;\n        --spinner-color: currentColor; \n    }\n"])));
var SvgComponent = function (props) {
    var IconComponent = usePresentationComponent([props.context ? props.context + ".icon" : "icon"]);
    if (IconComponent)
        return React.createElement(IconComponent, { type: props.type });
    var type = props.type, className = props.className, parseIcon = props.parseIcon, otherProps = __rest(props, ["type", "className", "parseIcon"]);
    var types = {
        arrow: Arrow,
        arrowup: Arrow,
        arrowleft: Arrow,
        arrowright: Arrow,
        edit: Edit,
        error: Error,
        cart: Cart,
        "cart-solid": CartSolid,
        close: Close,
        calendar: Calendar,
        attachment: Attachment,
        pdf: Pdf,
        check: Check,
        download: Download,
        settings: Gear,
        help: Help,
        notallowed: NotAllowed,
        spinning: Spinner,
        submit: Submit,
        search: Search,
        "offline-bolt": Bolt,
    };
    var Icon = types[type];
    if (!Icon) {
        if (!parseIcon || type === "string") {
            return null;
        }
        return React.createElement(React.Fragment, null, parse(type || ""));
    }
    return React.createElement(Icon, __assign({ className: getClassName(className, SVG, SVG + "-" + type) }, otherProps));
};
export var SvgIcon = styled(SvgComponent)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    ", "\n\n    transition: 0.3s transform;\n"], ["\n    ", "\n    ",
    "\n\n    transition: 0.3s transform;\n"])), function (_a) {
    var type = _a.type;
    return type === "error" ? "color: var(--ws-danger-text);" : "";
}, function (_a) {
    var type = _a.type;
    switch (type) {
        case "arrowup": return "transform: rotate(180deg);";
        case "arrowright": return "transform: rotate(-90deg);";
        case "arrowleft": return "transform: rotate(90deg);";
        default: return "transform: rotate(0);";
    }
});
var templateObject_1, templateObject_2;
